<script setup lang="ts">
import { ref, watch } from "vue"
import { fetchCoOpsStation, fetchTidePredStation } from "../lib/stations.ts"
import { fetchTides } from "../lib/tides.ts"
import type { NoaaTidePrediction, NoaaTidePredStation } from "../lib/types.ts"
import RequestInfoTable from "./RequestInfoTable.vue"
import TidesTable from "./TidesTable.vue"

const { id } = defineProps<{ id: string }>()

const loading = ref(true)
const error = ref<string>()
const location = ref<[number, number]>()
const station = ref<NoaaTidePredStation>()
const tides = ref<NoaaTidePrediction[]>()

// fill in the location ref using the NOAA CO-OPS API
fetchCoOpsStation(id, location, error)

// uses the location ref to get the station details from the TidePredStations API
watch(location, (newLocation) => {
  if (newLocation) {
    fetchTidePredStation(newLocation, error, station, 1)
  }
})

// use the station details to get the tides
watch(station, (newStation) => {
  if (newStation) {
    fetchTides(newStation, error, tides)
  }
})

watch(tides, () => {
  loading.value = false
})
</script>

<template>
  <div>
    <div v-if="loading">
      <p>Loading...</p>
    </div>
    <div v-else-if="error">
      <p>{{ error }}</p>
    </div>
    <template v-else-if="station">
      <template v-if="tides">
        <TidesTable :station="station" :tides="tides" />
      </template>
      <div v-else>
        <p>No Tides found for {{ id }}.</p>
      </div>
      <RequestInfoTable :station="station" />
    </template>
    <div v-else>
      <p>No Station found for {{ id }}.</p>
    </div>
  </div>
</template>

<!--suppress CssUnusedSymbol-->
<style scoped></style>
